<div #content *ngIf="Library">
  <div class="reader-ids">
    <div *ngFor="let r of Readers" class="reader-id">
      <reader-id [reader]="r"></reader-id>
    </div>
  </div>
</div>
